import React from 'react';
import initRedesignNav from 'utility/apply-redesign-nav';

class HudlLayoutWrapper extends React.Component {
  componentDidMount() {
    const { secondaryNavData } = this.props;

    initRedesignNav();

    if (secondaryNavData) {
      const setNav = () => {
        const navEl = document.querySelector('hudl-layout');
        if (navEl) navEl.secondaryNavData = secondaryNavData;
      };
      if (customElements.get('hudl-layout')) {
        setNav();
      } else {
        customElements.whenDefined('hudl-layout').then(setNav);
      }
    }
  }

  render() {
    return (
      <div className="prof-flex-container">
        {this.props.children}
      </div>
    );
  }
}

HudlLayoutWrapper.propTypes = {
  children: React.PropTypes.element,
  secondaryNavData: React.PropTypes.object,
};

export default HudlLayoutWrapper;
